import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as UsersActions from '../actions/users.actions';
import { MessageService } from 'primeng/api';
import { usersData } from 'src/app/STORE/selectors/users.selector';
@Injectable()
export class UsersEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);

  oldRecords = [];
  //   Get Users Data
  getUsersItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.getUsers),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.filter).subscribe(
            (usersDatas: any) => {
              if (action?.orgChange) {
                if (usersDatas) {
                  this.store.dispatch(
                    UsersActions.setUsers({ usersData: usersDatas.results, totalRecords: usersDatas.total })
                  );
                }
              } else {
                this.store.select(usersData).subscribe((data: any) => {
                  // console.log(organizationData.results)
                  // console.log(data.organizationData)
                  const oldusersData = data.usersData;
                  if (oldusersData !== undefined && oldusersData !== null) {
                    this.oldRecords = oldusersData;
                  }
                });
                if (usersDatas) {
                  const updateRecords = [...this.oldRecords, ...usersDatas.results];
                  // console.log(updateRecords)
                  const ids = updateRecords.map((o) => o.sid);
                  const filtered = updateRecords.filter(({ sid }, index) => !ids.includes(sid, index + 1));
                  // console.log(filtered)

                  this.store.dispatch(UsersActions.setUsers({ usersData: filtered, totalRecords: usersDatas.total }));
                }
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  getUsersItemsForSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.getUsersForSearch),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.filter).subscribe(
            (usersDatas: any) => {
              if (action?.orgChange) {
                if (usersDatas) {
                  this.store.dispatch(
                    UsersActions.setUsersForSearch({ usersData: usersDatas.results, totalRecords: usersDatas.total })
                  );
                }
              } else {
                this.store.select(usersData).subscribe((data: any) => {
                  // console.log(organizationData.results)
                  // console.log(data.organizationData)
                  const oldusersData = data.usersData;
                  if (oldusersData !== undefined && oldusersData !== null) {
                    this.oldRecords = oldusersData;
                  }
                });
                if (usersDatas) {
                  const updateRecords = [...this.oldRecords, ...usersDatas.results];
                  // console.log(updateRecords)
                  const ids = updateRecords.map((o) => o.sid);
                  const filtered = updateRecords.filter(({ sid }, index) => !ids.includes(sid, index + 1));
                  // console.log(filtered)

                  this.store.dispatch(
                    UsersActions.setUsersForSearch({ usersData: filtered, totalRecords: usersDatas.total })
                  );
                }
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  getUsersItemsWithSorting$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.getUsersWithSorting),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.filter).subscribe(
            (usersDatas: any) => {
              this.store.select(usersData).subscribe((data: any) => {
                // console.log(organizationData.results)
                // console.log(data.organizationData)
                const oldusersData = data.usersData;
                if (oldusersData !== undefined && oldusersData !== null) {
                  this.oldRecords = oldusersData;
                }
              });
              if (usersDatas) {
                const updateRecords = [...this.oldRecords, ...usersDatas.results];
                // console.log(updateRecords)
                const ids = updateRecords.map((o) => o.sid);
                const filtered = updateRecords.filter(({ sid }, index) => !ids.includes(sid, index + 1));
                // console.log(filtered)

                this.store.dispatch(UsersActions.setUsers({ usersData: filtered, totalRecords: usersDatas.total }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getSidBasedUsers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.getSidBasedUsers),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.sid;

          return this.baseService[apiConstants?.method](apiConstants).subscribe((sidUserData: any) => {
            this.store.dispatch(
              UsersActions.setSidBasedUsers({
                sidUserData: { ...sidUserData }
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
  srcText: string | null = null;
  // Get User Data Search
  getUsersBasedOnSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.getUsersBasedOnSearch),
        map((action: any) => {
          const searchQuery = {
            start: 0,
            length: 100,
            search: action.searchFields
          };
          /* if (this.srcText===action.searchText) return;
          else {
            this.srcText = action.searchText;
          } */
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            JSON.stringify(searchQuery)
          ).subscribe((fetchedUsersData: any) => {
            this.srcText = '';
            this.store.dispatch(
              UsersActions.setUsers({
                usersData: fetchedUsersData.results,
                totalRecords: fetchedUsersData.total
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  //   Save Users Data
  saveUsersItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.sentUsers),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.saveUsersData).subscribe(
            (response: any) => {
              if (action.apiConstants.method === 'put') {
                this.showMessage('success', 'User details updated successfully');
              } else if (action.apiConstants.method === 'post') {
                this.showMessage('success', 'User Created Successfully');
              }
              this.store.dispatch(UsersActions.updateUsers({ updateUsersData: response }));
            },
            (err) => {
              console.log('error');
              console.log(err);
              this.store.dispatch(
                UsersActions.getErrorMessage({
                  errorMessage: err
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  getAppForUsers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.getAppForUsers),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe(
            (setAppForUsers: any) => {
              //console.log(propertiesValues);
              this.store.dispatch(
                UsersActions.setAppForUsers({
                  sidAppData: setAppForUsers
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  // Delete Users Data
  deleteUsersItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersActions.sentDeleteUsers),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.usersId;
          return this.baseService[action.apiConstants?.method](apiConstants).subscribe(
            (_menuData: any) => {
              this.showMessage('success', 'User Deleted Successfully !');
              return this.store.dispatch(
                UsersActions.deleteUsers({
                  usersId: action.usersId
                })
              );
            },
            (_error) => {
              this.showMessage(
                'error',
                `An error occurred while attempting to delete the user ${action.userEmail}. Please try again later. If the issue persists, kindly contact our support team for assistance`
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
